export function Skeleton({
    width = "80%",
    height = "14px",
    className = "",
}: {
    width?: string
    height?: string
    className?: string
}) {
    return <span className={`table-skeleton ${className}`} style={{width, height, display: "inline-block"}} />;
}
